// removed by extract-text-webpack-plugin
module.exports = {"comment":"_3k5Do"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/plugins/code-block/highlighting-theme.scss
// module id = 788
// module chunks = 3 4 5 6 7